type WindowMessage = {
    type: string;
    payload?: string | number | boolean;
};

export const sendWindowMessage = (message: WindowMessage) => {
    const parentWindow = window.top;
    if (parentWindow) {
        parentWindow.postMessage(message, '*');
    }
};
